'use client';

import type { FC } from 'react';
import React, { useState } from 'react';
import ItineraryAccordion from '@/components/itinerary/ItineraryAccordion';
import GridContainer from '@/Layouts/GridContainer';
import type { ApiItinerary, ApiProduct } from '../../../api/model';
import { useTranslation } from '@/app/i18n/client';
import Keys from '@/Translations/generated/da/product.json.keys';
import type { PartialPageProps } from '@/types/cms/magnolia';
import type { ApiProductsCacheResponse } from '@ibe/api';
import Pdf from '@/components/itinerary/Pdf';

export type ItineraryProps = {
  theme: string;
  itinerary: ApiItinerary[];
  product?: Partial<ApiProduct>;
  pageProps?: PartialPageProps;
  selectedPackage?: ApiProductsCacheResponse;
};

const Itinerary: FC<ItineraryProps> = ({
  theme,
  itinerary,
  product,
  pageProps,
  selectedPackage
}) => {
  const { t } = useTranslation('product');

  const [allOpen, setAllOpen] = useState<boolean>(false);

  return (
    <GridContainer className={`itinerary ${theme}`}>
      <div className="itinerary__wrapper">
        <h2 className="itinerary__header">{t(Keys.dailyProgram)}</h2>
        <div>
          <Pdf pageProps={pageProps} product={product} selectedPackage={selectedPackage} />
        </div>
      </div>
      <div className="itinerary__showAll__btn">
        <button
          className="btn btn-secondary "
          onClick={() => setAllOpen(!allOpen)}
          aria-label="open all itinerary accordions"
        >
          <span className="itinerary__showAll__btn__text">
            {allOpen ? t(Keys.closeAll) : t(Keys.expandAll)}
          </span>
        </button>
      </div>
      {!!itinerary && itinerary.length > 0 && (
        <ItineraryAccordion
          groups={itinerary}
          setAllOpen={setAllOpen}
          allOpen={allOpen}
          pageProps={pageProps}
        />
      )}
    </GridContainer>
  );
};

export default Itinerary;
